import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styled } from '@mui/material/styles';
import {
    Box,
    Button,
    Drawer,
    IconButton,
    Divider,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import LeftSideMenu from './LeftSideMenu';

const WrapperSideMenu = styled(Box)`
    transition: width 0.5s ease-in-out;
`;

const PagesDrawer = ({
    deletePagesInTemplate,
    drawerSize,
    duplicatePagesInTemplate,
    isDarkMode,
    orderPagesInTemplate,
    selectedPageId,
    selectPage,
    setShowPagesDrawer,
    showNewPageModal,
    showPagesDrawer,
}) => {
    const { t } = useTranslation();
    return (
        <WrapperSideMenu
            sx={{ width: { xs: 0, md: showPagesDrawer ? 180 : 0 } }}
        >
            <Drawer
                sx={{
                    width: 180,
                    '& .MuiDrawer-paper': {
                        background: (theme) => theme.palette.primary.main,
                        width: 180,
                        boxSizing: 'border-box',
                        mt: { xs: '148px', md: 0 },
                        ml: {
                            xs: 0,
                            md: drawerSize === 'small' ? '50px' : '86px',
                        },
                        overflow: 'hidden',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={showPagesDrawer}
            >
                <Box
                    alignItems="center"
                    display="flex"
                    p={1}
                    sx={{ background: '#eef4fA' }}
                >
                    <Button
                        onClick={() => showNewPageModal(true)}
                        startIcon={<AddIcon fontSize="small" />}
                        variant="text"
                    >
                        <Box
                            component="span"
                            sx={{
                                overflow: 'hidden',
                                width: '5rem',
                                textAlign: 'left',
                                textOverflow: 'ellipsis',
                                textTransform: 'initial',
                                textWrap: 'nowrap',
                            }}
                        >
                            {t('New page')}
                        </Box>
                    </Button>
                    <IconButton
                        onClick={() => setShowPagesDrawer(false)}
                        sx={{
                            ml: 'auto',
                            color: isDarkMode ? '#1b1c1f' : 'inherit',
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Box>
                <Divider />
                <LeftSideMenu
                    canUpdate
                    deletePagesInTemplate={deletePagesInTemplate}
                    duplicatePagesInTemplate={duplicatePagesInTemplate}
                    orderPagesInTemplate={orderPagesInTemplate}
                    selectPage={selectPage}
                    selectedPageId={selectedPageId}
                    showNewPageModal={() => showNewPageModal(true)}
                />
            </Drawer>
        </WrapperSideMenu>
    );
};

PagesDrawer.propTypes = {
    deletePagesInTemplate: PropTypes.func,
    drawerSize: PropTypes.string,
    duplicatePagesInTemplate: PropTypes.func,
    isDarkMode: PropTypes.bool,
    orderPagesInTemplate: PropTypes.func,
    selectedPageId: PropTypes.string,
    selectPage: PropTypes.func,
    setShowPagesDrawer: PropTypes.func,
    showNewPageModal: PropTypes.func,
    showPagesDrawer: PropTypes.bool,
};

export default PagesDrawer;
